export const API_URL = "https://hi0y3kmf9a.execute-api.us-west-2.amazonaws.com/prod"
export const S3_URL = "https://mycookiesservicestack-widgetsdocumentstore3dad1a5-14abgwm2y79x2.s3-us-west-2.amazonaws.com/"